<template>
  <div class="all_nav">
    <div class="top_search">
      <el-input
        class="nav_search"
        placeholder="请输入关键字"
        prefix-icon="el-icon-search"
        v-model="filterText"
        size="small"
      ></el-input>
      <el-dropdown trigger="click" @command="handleCommandConfig">
        <span class="config_nav">
          一键配置<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="item in presetConfigList" :key="item.id" :command="item">{{item.name}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="nav_main">
      <div class="nav_item" v-for="item in treeData" :key="item.id">
        <p>
          <i class="el-icon-house"></i>
          <span>{{ item.name }}{{ $store.state.nav.currentPlatform[item.id].currentShopName!=''?'-' + $store.state.nav.currentPlatform[item.id].currentShopName:'' }}</span>
          <el-dropdown @command="handleCommand" v-if="item.shops.length > 0" trigger="click">
            <i class="el-icon-caret-bottom"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="shopItem in item.shops" :key="shopItem.platformShopId" :command="{ 'shopInfo':shopItem,'platformId':item.id}">{{shopItem.name}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </p>
        <el-tree
          :data="item.menus"
          default-expand-all
          node-key="id"
          ref="tree"
          class="nav_item_tree"
          :props="navDefaultProps"
          :filter-node-method="filterNode"
        >
          <span class="custom-tree-node" slot-scope="{ data }" @click="goLocation(item,data)">
            <span>{{data.name}}</span>
            <template v-if="data.config.route">
              <i class="el-icon-star-on" v-if="data.hasCollected" @click.stop="delNav(item,data)"></i>
              <i class="el-icon-star-off" v-else @click.stop="editNavName(item,data)"></i>
            </template>

          </span>
        </el-tree>
      </div>
    </div>
    <edit-nav-alias :nav-config="navConfig" :show-edit="showEditBox" @handleCancle="handleCancel" @handleConfirm="handleConfirm"></edit-nav-alias>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import store from '@/store/index';
export default {
  watch: {
    filterText(val) {
      for(let i = 0; i < this.platformList.length; i++){
        this.$refs.tree[i].filter(val);
      }
    }
  },
  computed:{
    ...mapGetters(['presetConfigList','platformList','userConfig']),
    treeData(){
      // 很恶心的方法  循环判断获取收藏状态   急于开发  下面没有递归  只有3级目录满足需求
      if(!this.platformList)return;

      let platformList = JSON.parse(JSON.stringify(this.platformList));
      let _this = this;
      platformList.forEach(item=>{
        let menus = item.menus;
        let res = {};
        let tree = [];

        if(menus.length == 0) return;
        menus.forEach((v) => {
          if (res[v['parentId']]) {
            res[v['parentId']].push(v);
          } else {
            res[v['parentId']]=[];
            res[v['parentId']].push(v);
          }
        });

        res['0'].forEach((v) => {
          let children = [];
          if (res[v['id']]){
            res[v['id']].forEach((i)=>{
              let children = [];
              if(res[i['id']]){
                children = res[i['id']];
              }
              i['children'] = children;
            })
            children = res[v['id']];
          }
          v['children'] = children;
          tree.push(v)
        });
        item.menus = tree;
      })
      platformList.forEach(item=>{
        let currentPlatformShopId = _this.$store.state.nav.currentPlatform[item.id].currentShopId;
        if(item.menus.length == 0)return;
        item.menus.forEach(v=>{
          if(v.children.length == 0){
            v['hasCollected'] = false;
            _this.userConfig.config.forEach(collected=>{
              if(item.id == collected.platformId && v.id == collected.menuId && currentPlatformShopId == collected.platformShopId){
                v['hasCollected'] = true;
                return;
              }
            })
          }else{
            v.children.forEach(e=>{
              if(e.children.length == 0){
                e['hasCollected'] = false;
                _this.userConfig.config.forEach(collected=>{
                  if(item.id == collected.platformId && e.id == collected.menuId && currentPlatformShopId == collected.platformShopId){
                    e['hasCollected'] = true;
                    return;
                  }
                })
              }else{
                e.children.forEach(j=>{
                  j['hasCollected'] = false;
                  _this.userConfig.config.forEach(collected=>{
                    if(item.id == collected.platformId && j.id == collected.menuId && currentPlatformShopId == collected.platformShopId){
                      j['hasCollected'] = true;
                      return;
                    }
                  })
                })
              }
            })
          }
        })
      })

      return platformList;
    },
  },
  data() {
    return {
      filterText: "",
      showEditBox:false,
      navConfig:{},
      navDefaultProps: {
        children: "children",
        label: "name",
      }
    };
  },
  mounted(){

  },
  methods:{
    ...mapMutations(['EDIT_CURRENT_PLATFORM']),
    ...mapActions(['saveUserConfig','delUserConfig']),
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    goLocation(item,data){
      if(data.children && data.children.length > 0) return;
      var curPlatformShopId = this.$store.state.nav.currentPlatform[item.id].currentShopId;
      var apskMenuId = '';
      // 安排授课id正式37 测试11
      if(process.env.NODE_ENV=='development' || process.env.NODE_ENV=='testing'){
        apskMenuId = 11;
      }else if(process.env.NODE_ENV=='production'){
        apskMenuId = 37;
      }
      if(item.id == 2 && curPlatformShopId == 20 && data.id == apskMenuId){
        // 19直播店铺安排授课链接跳转为新链接
        var url = this.getUrlByConfig(item,data).replace('give-lessons','give-lessons-nineteen');
      }else{
        var url = this.getUrlByConfig(item,data);
      }
      var rurl = url.replace('http://','//');
      var openType = "";
      if(item.openNewWindow == 1){
        openType = '_blank';
      }else{
        openType = '_self';
      }
      let i = '',j='';
      if(rurl.indexOf('?') == -1){
        i = '?';
      }else{
        i = '&';
      }
      if(rurl.indexOf('id=') == -1){
        j = 'id=1&';
      }else{
        j = '';
      }
      rurl += (i + j + `from=${encodeURIComponent(url)}`);
      this.postMessage('getTopLocation');
      if(top.location == self.location){
        window.open(rurl,openType);
      }else{
        // top.location.replace(rurl);
        // top.open(rurl,openType);
        if(item.openNewWindow == 1){
          window.open(rurl,'_blank');
        }else{
          top.location.replace(rurl);
        }
      }
    },
    editNavName(item,data){
      var curPlatformShopId = this.$store.state.nav.currentPlatform[item.id].currentShopId;
      var curPlatformShopName = this.$store.state.nav.currentPlatform[item.id].currentShopName;
      this.navConfig = {
        "platformId" : item.id,
        "platformConfig" : item.config,
        "platformShopId" : curPlatformShopId,
        "url":data.config.route,
        "menuId":data.id,
        "menuName":item.shops.length>0?`${data.name}-${curPlatformShopName}`:`${data.name}`
      };
      this.showEditBox = true;
    },
    postMessage(type){
      // 发送消息  通知message事件绑定完毕  load
      window.parent.postMessage(JSON.stringify({
        type:type
      }), '*');
    },
    getUrlByConfig(item,data){
      var curPlatformShopId = this.$store.state.nav.currentPlatform[item.id].currentShopId;
      var route = data.config.route.replace(/\{platformShopId\}/,curPlatformShopId);
      // 正则替换url中的{}
      var arr = /\{(.*?)\}/g.exec(route);
      if(arr && arr.length>0){
        var r1 = item.config[arr[1]];
        var url = route.replace(arr[0],r1);
        return url;
      }else{
        return route;
      }
    },
    delNav(item,data){
      var url = this.getUrlByConfig(item,data);
      var curPlatformShopId = this.$store.state.nav.currentPlatform[item.id].currentShopId;
      let config = {
        'menuId':data.id,
        'menuName':data.name,
        'platformShopId':curPlatformShopId,
        'url':url,
        'platformId' : item.id
      }
      this.delUserConfig(config).then(res=>{

      })
    },

    // 一键配置下拉框选择触发
    handleCommandConfig(command){
      var _this = this;
      var h = _this.$createElement;
      if(_this.userConfig.config.length>0){
        _this.$msgbox({
          title: "",
          type: "warning",
          showClose: false,
          closeOnClickModal: false,
          message: h("p", null, [
            h("span", null, "确认要将收藏一键配置为"),
            h("span", { style: "color: red;margin: 0 5px;" }, command.name),
            h("span", null, "吗？ "),
            h(
              "p",
              { style: "color: red" },
              "一键配置将覆盖已收藏内容"
            ),
          ]),
          showCancelButton: true,
          confirmButtonText: "继续",
          callback: function (action, instance) {
            if (action == "confirm") {
              _this.saveUserConfig(command.config).then(res=>{
                console.log('一键配置成功');
              })
            }
          },
        });
      }else{
        _this.saveUserConfig(command.config).then(res=>{
          console.log('一键配置成功');
        })
      }
    },

    // 下拉框选择店铺触发
    handleCommand(command){
      this.$store.commit('EDIT_CURRENT_PLATFORM',command);
    },

    // 修改名字弹窗确认
    handleConfirm(newConfig) {
      var _this = this;
      var route = newConfig.url;
      // 正则替换url中的{}
      if(route.match(/\{platformShopId\}/) && route.match(/\{platformShopId\}/).length>0){
        route = route.replace(/\{platformShopId\}/,newConfig.platformShopId);
      }
      if(route.match(/\{(.*?)\}/) && route.match(/\{(.*?)\}/).length>0){
        var arr = /\{(.*?)\}/g.exec(route);
        var r1 = newConfig.platformConfig[arr[1]];
        route = route.replace(arr[0],r1);
      }
      var config = {
        'url': route,
        'menuId':newConfig.menuId,
        'menuName':newConfig.menuName,
        'platformShopId':newConfig.platformShopId,
        'platformId' : newConfig.platformId,
        'sort' : newConfig.sort
      };
      _this.saveUserConfig(config).then(res=>{

      })
      _this.showEditBox = false;
    },
    // 修改名字弹窗取消
    handleCancel(){
      this.showEditBox = false;
    }
  }
};
</script>

<style lang="less">
@media screen and (min-width: 1080px){
  .nav_main{max-height: 1100px;}
}
.all_nav {
  background: #fff;
  padding: 20px;
  .top_search {
    .nav_search {
      width: calc(90% - 100px);
      border-radius: 5px;
    }
    .el-dropdown{
      width: 100px;
      text-align: center;
      float: right;
      vertical-align: middle;
      border: 1px solid #dcdfe6;
      border-radius: 5px;
      height: 32px;
      line-height: 32px;
      cursor: pointer;
      .config_nav {
        outline: none;
      }
    }

  }
  .nav_main {
    padding-top: 20px;
    display: inline-block;
    columns: 200px 4;
    width: 100%;
    overflow: auto;
    column-gap: 12px;
    // display: flex;
    // justify-content: space-between;
    // flex-wrap: wrap;
    .nav_item {
      // width: 25%;
      width: 100%;
      display: inline-block;
      p {
        margin: 0;
        padding: 10px 0;
        border-bottom: 1px solid #efefef;
        >i:first-of-type {
          color: #1890FF;
        }
        span {
          font-size: 12px;
          font-weight: 700;
        }
      }
      .nav_item_tree {
        margin-top: 10px;
        .custom-tree-node{
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 12px;
          padding-right: 8px;
          span{
          }
          .el-icon-star-on{
            color:#ff9900;
            font-size: 20px;
          }
          .el-icon-star-off{
            color: #ff9900;
            display: none;
            font-size: 20px;
          }
        }
        .custom-tree-node:hover{
          .el-icon-star-off{
            display: block;
          }
        }
      }
    }
  }
}
.el-dropdown-menu{
  max-height: 400px;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/pages/all-nav/index.vue